import { useState, useEffect } from 'react';
import { Divider, withStyles } from '@material-ui/core';
import SectionHeader from './SectionHeader';
import { withAppConfig } from '../../../../../appConfigContext';
import { compose } from 'recompose';
import CustomCheckbox from '../../../Dispatch/RouteExecution/DriverPopUp/common/CustomCheckbox';

const styles = (theme) => ({
  container: {
    paddingBottom: 8
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  }
});

const fieldNames = {
  isUnattendedDelivery: 'isUnattendedDelivery',
  isDeliveryProofRequired: 'isDeliveryProofRequired'
};

const options = [
  {
    key: fieldNames.isUnattendedDelivery,
    labelText: 'Unattended Delivery',
    featureFlag: 'enableUnattendedDeliveryInCustomerManagement',
    disabled: false
  },
  {
    key: fieldNames.isDeliveryProofRequired,
    labelText: 'Delivery Proof Required',
    featureFlag: 'enableProofOfDeliveryInCustomerManagement',
    disabled: false
  }
];

const DeliveryInstructions = ({ classes, configJSON, data, updateData }) => {
  const [enabledOptions, setEnabledOptions] = useState([]);

  const getEnabledOptions = () => {
    return options.filter((option) => configJSON?.[option.featureFlag]);
  };

  // Business logic: When unattended delivery is selected, delivery proof is required
  const handleUnattendedDeliveryRequirements = (isUnattendedDelivery) => {
    if (isUnattendedDelivery) {
      // Auto-select delivery proof required and disable the option
      updateData?.(fieldNames.isDeliveryProofRequired, true);
      updateOptionDisabledState(fieldNames.isDeliveryProofRequired, true);
    } else {
      updateOptionDisabledState(fieldNames.isDeliveryProofRequired, false);
    }
  };

  const updateOptionDisabledState = (optionKey, isDisabled) => {
    setEnabledOptions((prev) =>
      prev.map((option) => ({ ...option, disabled: option.key === optionKey && isDisabled }))
    );
  };

  useEffect(() => {
    setEnabledOptions(getEnabledOptions());
  }, []);

  useEffect(() => {
    handleUnattendedDeliveryRequirements(data?.isUnattendedDelivery);
  }, [data?.isUnattendedDelivery]);

  const handleChange = (field) => (event) => {
    const value = event.target.checked;
    updateData?.(field, value);
  };

  if (enabledOptions.length === 0) {
    return null;
  }

  return (
    <div className={classes.container}>
      <Divider className={classes.divider} />
      <SectionHeader title="Delivery Instructions" />
      <div className={classes.checkboxContainer}>
        {enabledOptions.map(({ key, labelText, disabled }) => (
          <CustomCheckbox
            key={key}
            name={key}
            labelText={labelText}
            isChecked={Boolean(data?.[key])}
            handleChange={handleChange(key)}
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  );
};

export default compose(withAppConfig, withStyles(styles))(DeliveryInstructions);
